import { inject } from "@angular/core";
import { Subject } from "rxjs";
import { BsModalRef } from "ngx-bootstrap/modal";

export abstract class BaseModal {
    protected _bsModalRef = inject(BsModalRef);
    public afterClosed = new Subject<any>();

    public onClose(): Subject<any> {
        return this.afterClosed;
    }

    protected onConfirm(obj: any): void {
        this.afterClosed.next(obj);
        this._bsModalRef.hide();
    }

    protected onCancel(): void {
        this.afterClosed.next(false);
        this._bsModalRef.hide();
    }
}
